export default {
  PRIMARY: '#05C49B',
  PRIMARY_DARK: '#049C7C',
  PRIMARY_LIGHT: '#9BE7D7',
  BACKGROUND_LIGHT: '#F5F5F5',
  SECONDARY: '#272727',
  TEXT_PRIMARY: '#000000',
  TEXT_SECONDARY: '#FFFFFF',
};
